import Fetcher from '../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  VALIDATION_MESSAGES
} from '../../constants'
import {
  CCAddRemoveToHospitalUserRequest,
  CCReassignmentOptionsRequest,
  CCReassignmentOptionsResponse,
  CCReassignmentRequest,
  CCReassignRequest,
  CCRelatedItemsRequest,
  CCRelatedItemsResponse,
  ChangeCommunityLevelRequest,
  TRemoveCCFromUserProfileRequest,
  UserContractCategoriesRequest,
  UserContractCategoriesResponse,
  VotingPanelMembershipStatusRequestPayload
} from './types'

const fetcher = new Fetcher({})

export const getUserContractCategories = async (uuid, params) =>
  fetcher.request<
    UserContractCategoriesRequest,
    UserContractCategoriesResponse
  >({
    url: `${API_DICTIONARY.USERS}${uuid}/${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET,
    params
  })

export const changeCommunityLevel = async (userId, ccId, data) =>
  fetcher.request<ChangeCommunityLevelRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.UPDATE_LEVEL}`,
    method: HTTP_METHODS.PATCH,
    data
  })

export const getCCRelatedItemsRequest = async (userId, ccId) =>
  fetcher.request<CCRelatedItemsRequest, CCRelatedItemsResponse>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.CHECK_RELATED_ITEMS}`,
    method: HTTP_METHODS.GET
  })

export const getCCAssignmentOptions = async ({ userId, ccId }) =>
  fetcher.request<
    CCReassignmentOptionsRequest,
    ResponseWithPagination<CCReassignmentOptionsResponse>
  >({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.OPTIONS}${API_DICTIONARY.OWNER}`,
    method: HTTP_METHODS.GET
  })

export const getCCReassignmentOptions = async (userId, ccId, reassignmentId) =>
  fetcher.request<
    CCReassignmentOptionsRequest,
    ResponseWithPagination<CCReassignmentOptionsResponse>
  >({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.REASSIGNMENT_REQUESTS}${reassignmentId}/${API_DICTIONARY.OPTIONS}${API_DICTIONARY.OWNER}`,
    method: HTTP_METHODS.GET
  })

export const reassignCCResponsibleRequest = async ({ userId, ccId, data }) =>
  fetcher.request<CCReassignRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.REASSIGN}`,
    method: HTTP_METHODS.POST,
    data
  })

export const getReassignmentRequestDataRequest = async ({
  userId,
  ccId,
  reassignmentId
}) =>
  fetcher.request<unknown, CCReassignmentRequest>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.REASSIGNMENT_REQUESTS}${reassignmentId}/`,
    method: HTTP_METHODS.GET
  })

export const updateReassignmentRequestDataRequest = async ({
  userId,
  ccId,
  reassignmentId,
  data
}) =>
  fetcher.request<CCReassignRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.REASSIGNMENT_REQUESTS}${reassignmentId}/`,
    method: HTTP_METHODS.PUT,
    data
  })

export const unassignCCRequest = (userId, ccId, data) =>
  fetcher.request<CCReassignRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.UNASSIGN}`,
    method: HTTP_METHODS.POST,
    data
  })

export const removeCCFromUserProfile = (userId: string, ccIds: string[]) =>
  fetcher.request<TRemoveCCFromUserProfileRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${API_DICTIONARY.DELETE}`,
    method: HTTP_METHODS.POST,
    data: { contract_categories: ccIds }
  })

export const addCCToHospitalUser = async ({ userId, hospitalId, data }) =>
  fetcher.request<CCAddRemoveToHospitalUserRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.HOSPITALS}${hospitalId}/${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.POST,
    data,
    successMessage: VALIDATION_MESSAGES.SM0202
  })

export const removeCCFromHospitalUserProfile = ({ userId, hospitalId, data }) =>
  fetcher.request<CCAddRemoveToHospitalUserRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.HOSPITALS}${hospitalId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${API_DICTIONARY.BULK_REMOVE}`,
    method: HTTP_METHODS.POST,
    data
  })

export const setupContractCategoryVotingPanelMembershipStatus = ({
  userId,
  hospitalId,
  data
}) =>
  fetcher.request<VotingPanelMembershipStatusRequestPayload, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.HOSPITALS}${hospitalId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${API_DICTIONARY.VOTING_PANEL_MEMBERSHIP}`,
    method: HTTP_METHODS.POST,
    data
  })

export const getHospitalUserContractCategories = async ({
  userId,
  hospitalId,
  params
}) =>
  fetcher.request<
    UserContractCategoriesRequest,
    UserContractCategoriesResponse
  >({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.HOSPITALS}${hospitalId}/${API_DICTIONARY.CONTRACT_CATEGORIES}`,
    method: HTTP_METHODS.GET,
    params
  })

export const partialUpdateReassignmentRequest = async ({
  userId,
  ccId,
  reassignmentId,
  data
}) =>
  fetcher.request<CCReassignRequest, unknown>({
    url: `${API_DICTIONARY.USERS}${userId}/${API_DICTIONARY.CONTRACT_CATEGORIES}${ccId}/${API_DICTIONARY.REASSIGNMENT_REQUESTS}${reassignmentId}/`,
    method: HTTP_METHODS.PATCH,
    data
  })
